module.exports = __webpack_public_path__ + "static/media/link.6ee38fe1.svg";